export const SectionLabel = ({ index, children, className = "" }) => (
  <p className={`label-caps flex items-center gap-4 ${className}`}>
    {index && <span className="font-mono text-[11px] tracking-normal">({index})</span>}
    <span className="h-px w-10 bg-current opacity-50" />
    {children}
  </p>
);
